module.exports = __webpack_public_path__ + "static/super-admin-faq-shop-32bda860f75c487bc7bad33b8321c73f.png";